import React from "react";
import {
  getCurrentP1Region,
  getPortalUrlForRegion,
} from "../utils/p1Region";

/**
 * AU ↔ NZ member-portal switcher for the top header.
 * Current site is detected from hostname (deployed) or REACT_APP_P1_REGION (local).
 */
function RegionPortalSwitcher() {
  const currentRegion = getCurrentP1Region();

  const goToRegion = (region) => {
    if (region === currentRegion) return;
    const target = getPortalUrlForRegion(region);
    // Full navigation — Auth0 / session are per-domain.
    window.location.assign(target);
  };

  const btnClass = (region) => {
    const active = region === currentRegion;
    return [
      "px-3 py-0.5 text-sm font-semibold transition-colors",
      active
        ? "bg-[#1e3a5f] text-white"
        : "bg-transparent text-[#6D6D6D] hover:text-[#1e3a5f]",
    ].join(" ");
  };

  return (
    <div
      className="flex items-center h-[48px] pr-2 border-r border-slate-200 mr-1"
      title={`Current portal: ${currentRegion}. Switch between Australia and New Zealand.`}
    >
      <div className="inline-flex items-center gap-1 rounded border border-slate-300 overflow-hidden bg-white px-0.5">
        <button
          type="button"
          className={btnClass("AU")}
          aria-current={currentRegion === "AU" ? "true" : undefined}
          aria-label="Switch to Australia portal"
          onClick={() => goToRegion("AU")}
        >
          AU
        </button>
        <span className="text-slate-300 select-none px-0.5" aria-hidden="true">
          |
        </span>
        <button
          type="button"
          className={btnClass("NZ")}
          aria-current={currentRegion === "NZ" ? "true" : undefined}
          aria-label="Switch to New Zealand portal"
          onClick={() => goToRegion("NZ")}
        >
          NZ
        </button>
      </div>
    </div>
  );
}

export default RegionPortalSwitcher;
